// extracted by mini-css-extract-plugin
export default {"wrapper":"mm-z","response":"nm-z","error":"om-z","disabled":"pm-z","buttons":"qm-z","feedbackQuestionSection":"rm-z","yesNoWrapper":"sm-z"};